import axios from "axios";

// Create Axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API, // <-- Change to your API URL
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor: add token automatically
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // or from Redux store
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Optional: Response interceptor for global error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 400 &&
      error.response?.data?.code === "INSUFFICIENT_CREDITS"
    ) {
      import("../Store").then(({ default: store }) => {
        import("../Store/uiSlice").then(({ openExtraCreditsModal }) => {
          store.dispatch(openExtraCreditsModal());
        });
      });
    }

    // Example: auto-logout on 401
    if (error.response?.status === 401) {
      console.warn("Unauthorized - maybe redirect to login");
      // Example: window.location = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
